export default __webpack_public_path__ + "static/media/icon_reader_grey.3fe23386.svg";